import { Component, OnInit } from '@angular/core';
import { AgentStoreDetail } from '../../_services/agentlocator/agentlocatorservice';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Router } from '@angular/router';
declare var ___MobileAgent___: any;
@Component({
  selector: 'app-agent-locator-agentdetail',
  templateUrl: './agent-locator-agentdetail.component.html',
  styles: ['./agent-locator.css'],
  providers: [AlertService]
})
export class AgentLocatorAgentdetailComponent implements OnInit {
  storeDetail;
  agentImgData;
  constructor(
    private agentLocatorstoreserv: AgentStoreDetail,
    public utilServ: utilityService,
    private smService: SendMoneyService,
    private alertService: AlertService,
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit() {

    this.agentLocatorstoreserv.getAgentDetail().subscribe(data => {
      this.storeDetail = data;
      this.smService.getstoreimage(this.utilServ.getObjectText(data.storeId)).subscribe(
        storeData => {
          if (
            storeData.Envelope.Body.AgentStoreImageResponse.StatusCode == 1000 ||
            storeData.Envelope.Body.AgentStoreImageResponse.StatusCode == 10021 // Image not founde
          ) {
            this.agentImgData = 'data:image/gif;base64,' + storeData.Envelope.Body.AgentStoreImageResponse.StoreImageData;
          }
        },
        error => {
          //console.log('Unable to fetch Store Image');
        }
      );
    });
    if (this.storeDetail == undefined) {
      this.router.navigate(['/dashboard']);
    }
    // Agent Image
  }

  openGoogleDirectionmap(c) {
    // window.open(
    //   `https://www.google.com/maps/dir/${this.userGioLocation.latitude},${this.userGioLocation.longitude}/${Number.parseFloat(c.Address.Latitude.__text)},${Number.parseFloat(
    //     c.Address.Longitude.__text
    //   )}`
    // );
    // window.open('https://www.google.com/maps?saddr=My+Location&daddr=' + Number.parseFloat(c.Address.Latitude.__text) + ',' + Number.parseFloat(c.Address.Longitude.__text));
    // window.open(
    //   'https://www.google.com/maps?saddr=My+Location&daddr=' +
    //     this.utilityServ.getObjectText(c.Address.Address1) +
    //     ' ' +
    //     this.utilityServ.getObjectText(c.Address.City) +
    //     ' ' +
    //     this.utilityServ.getObjectText(c.Address.StateCode) +
    //     ' ' +
    //     this.utilityServ.getObjectText(c.Address.CountryCode)
    // );
    //  window.open('https://www.google.com/maps?saddr=My+Location&daddr=' + c.Address.Address1);
    // https://www.google.com/maps?saddr=My+Location&daddr=43.12345,-76.12345
    // https://www.google.com/maps?saddr=41.6908605,-85.97&daddr=1216 W Bristol St, Elkhart, IN 46514, USA
    ___MobileAgent___.GetDirections(this.utilServ.getObjectText(c.Address.Address1) +
        ' ' +
        this.utilServ.getObjectText(c.Address.City) +
        ' ' +
        this.utilServ.getObjectText(c.Address.StateCode) +
        ' ' +
        this.utilServ.getObjectText(c.Address.CountryCode)
    );
  }

  callStore(phoneNumber) {
    if (phoneNumber != undefined) {
      if (___MobileAgent___.IsWrapper()) {
        ___MobileAgent___.OpenExternalLink("tel:" + this.utilServ.getObjectText(phoneNumber));
      } else {
        this.alertService.openErrorAlert(
          this.translate.instant('Common_lblInfo'),
          this.translate.instant('Message_lblCustomerCareContactPrefix') + ' ' + this.utilServ.getObjectText(phoneNumber) + ' ' + this.translate.instant('Common_lblStoreContact')
        );  
      }
    } else {
      this.alertService.openErrorAlert(this.translate.instant('Common_lblInfo'), this.translate.instant('Message_customerCareError'));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/agentlocator/agent-locator-agentdetail/agent-locator-agentdetail.component.ts